import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function ShopTitle() {
  return <section data-section-id="162035" id="shop-title" className="relative bg-background text-foreground bg-gradient-to-b from-accent/30 to-background overflow-hidden py-16 md:py-24">
      {}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: `linear-gradient(to right, var(--secondary) 1px, transparent 1px), linear-gradient(to bottom, var(--secondary) 1px, transparent 1px)`,
      backgroundSize: '32px 32px'
    }} aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary tracking-tight font-serif uppercase mb-6">
          The Village Market
        </h1>

        <Breadcrumb>
          <BreadcrumbList className="text-muted-foreground justify-center sm:justify-center">
            <BreadcrumbItem>
              <BreadcrumbLink asChild className="hover:text-primary transition-colors">
                <Link to="/HomePage">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-muted-foreground/50" />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-primary font-medium">Shop</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </section>;
}